import React, { useState, useEffect, setState, useRef } from 'react';
import { get as _get } from 'lodash-es';
import { FormattedNumber } from 'react-intl';
import CompatioAnalytics from '../../../api/CompatioAnalytics';
import { useSwipeable } from 'react-swipeable';
import { ProductPriceString } from '../../dc-utils/ProductPriceString';
import { createShareableLinkUrl } from '../../utils/HelperMethods';
import CopyBoard from '../outfit-component/copycmd';
const defaultCurrencySub = _get(
  window,
  'compatioConfig.compatibleProducts.currencySub'
);

const userId = CompatioAnalytics.getUserId();

const OutFitComponent = ({
  configData,
  outfitList,
  setOutfitList,
  setIsOpen,
  handleRemoveItem,
  optionsDetails,
  dcConfigDetails,
  appliedFilters,
  currentCategory,
  setCategoryWiseFilters,
  finalArray,
  setFinalArray,
  categoryWiseFilters,
  checkprefiltered,
  categoyrListPreSets,
  optionalListPreSets,
  setAppliedFilters,
  setAfterApplyFilter,
  setApplySelectedFilters,
  currentOutfit,
  setCurrentCategory,
  setLoading,
  SetIsFull,
  inputData,
  setInputData,
  afterClearOutFit,
  setAfterClearOutFit,
  afterClearOutFitProductPage,
  setAfterClearOutFitProductPage,
  setShowOptions,
  OpenPopReels,
  setOpenPopReels,
  fetchData,
  afterClearBuilderCallAgain,
  baseItemProductSku,
  stopRunShareFun,
  setStopRunShareFun,
}) => {
  // Create a new AbortController for the new API call
  const mobileButtonText = dcConfigDetails.mobileviewButtonText;
  const title =
    configData.configurator && configData.configurator.sidebar_heading;

  const currentAdded = outfitList.map(each => each.merchantProductSku);
  // const isReelPresent = outfitList.find(each => each.categoryName === 'Reels');
  const isReelPresent = outfitList.find(each => {
    const name = each.categoryName?.toLowerCase();
    const current = each.categoryCurrent?.toLowerCase();

    return name?.includes('reel') || current?.includes('reel');
  });
  // console.log(isReelPresent.merchantProductSku,'isReelPresent')
  const _buttontext =
    configData.configurator !== undefined
      ? configData.configurator.sidebar_button_heading === ''
        ? 'Add Outfit To Cart'
        : configData.configurator.sidebar_button_heading
      : 'Add Outfit To Cart';

  const [outfitHeading, setOutfitHeading] = useState(title);
  const [buttonText, setButtonText] = useState(_buttontext);
  const [variantsAdded, setVariantsAdded] = useState([]);
  const [outfitbuttonshow, setOutfitbuttonshow] = useState(false);

  const [shareButtonTitle, setshareButtonTitle] = useState('Share Outfit');
  const [ReelId, setReelId] = useState(
    isReelPresent === undefined ? '-1' : isReelPresent.merchantProductSku
  );
  console.log(ReelId, 'ReelId');
  const abortControllerRef = useRef(null);

  const getTotal = () => {
    let total = 0;
    outfitList.forEach(element => {
      total += element.price;
    });
    return total;
  };
  useEffect(() => {
    if (OpenPopReels == false) {
      setOutfitbuttonshow(true);
    }
    //console.log(outfitList);
    //createSharableLinkUrl(outfitList, 'selectedData');
    // console.log(categoyrListPreSets,'gaurav',optionalListPreSets)

    const currentAdded = outfitList.map(each => each.merchantProductSku);
    // const isReelPresent = outfitList.find(each =>
    //   each.categoryName
    //     ? each.categoryName === 'Reels' ||
    //       each.categoryName.split('__')[2] === 'Fly Reel'
    //     : ''
    // );
    const isReelPresent = outfitList.find(each => {
      const name = each.categoryName?.toLowerCase();
      const current = each.categoryCurrent?.toLowerCase();

      return name?.includes('reel') || current?.includes('reel');
    });
    // if (isReelPresente[isReelPresente.length - 1] == true) {
    //   setShowOptions(true);
    // } else {
    //   setShowOptions(false);
    // }
    setVariantsAdded(currentAdded);
    setReelId(
      isReelPresent === undefined ? '-1' : isReelPresent.merchantProductSku
    );
  }, [outfitList]);

  useEffect(() => {
    if (stopRunShareFun && abortControllerRef.current) {
      abortControllerRef.current.abort();
      setStopRunShareFun(false); // Reset the flag after aborting
      setshareButtonTitle('Share Outfit'); // Reset the button title
      setInputData(null); // Clear input data if necessary
      console.log('Fetch aborted due to stopRunShareFun.');
    }
  }, [stopRunShareFun, setStopRunShareFun, setshareButtonTitle, setInputData]);

  let productList = null;
  if (outfitList && outfitList.length !== 0) {
    productList = outfitList.map(eachitem => {
      // console.log(eachitem, 'eachitem', eachitem.categoryName);
      let discountPricevar = [];
      if (
        eachitem.categoryName !== undefined && eachitem.groupset
          ? eachitem.groupset.split('__')[2]
          : eachitem.categoryCurrent != 'Backing'
      ) {
        discountPricevar =
          eachitem.compareAtPrice && '$' + eachitem.compareAtPrice;
      }
      // console.log(eachitem,'eachitem')
      return (
        <div
          className="outfit-product-details"
          key={eachitem.merchantProductSku}
        >
          <img src={eachitem.url_image} width={'100px'} />
          <p className="outfit-product-name-wrap">
            <strong>
              {eachitem.categoryName == 'Backing'
                ? eachitem.categoryName
                : eachitem.categoryName != undefined
                ? eachitem.groupset
                  ? eachitem.groupset.split('__')[2]
                  : eachitem.categoryCurrent
                : eachitem.categoryCurrent}
            </strong>
            <br></br>
            {eachitem.variantName.includes('Default Title')
              ? eachitem.productName
              : eachitem.variantName}
          </p>
          <div className="outfit-product-price-wrap">
            <ProductPriceString
              price={eachitem.price}
              compareAtPrice={eachitem.compareAtPrice}
              currency={
                eachitem.currency !== undefined ? eachitem.currency : 'USD'
              }
              place="Outfit"
            />
            <a
              onClick={() => {
                handleRemoveItem(eachitem);
                if (eachitem.categoryName != 'Backing') {
                  setLoading(true);
                  SetIsFull(false);
                }
              }}
            >
              Remove
            </a>
          </div>
        </div>
      );
    });
  }

  const handlersUp = useSwipeable({
    onSwipedUp: () => {
      window.$('.swipup').click();
    },
  });

  const handlersDown = useSwipeable({
    onSwipedDown: () => {
      window.$('.close-outfit').click();
    },
  });

  window.$('.swipup').click(function() {
    window.$('#desktop-outfit').slideDown();
    window.$('.outfit-footer').slideDown();
  });
  window.$('.close-outfit').click(function() {
    window.$('#desktop-outfit').slideUp();
    window.$('.outfit-footer').slideUp();
  });

  const ClearAllData = () => {
    // setOutfitList(currentOutfit);
    window.history.pushState(
      'forward',
      null,
      window.location.origin + window.location.pathname
    );
    if (currentOutfit[0] == ' ') {
      setOutfitList([]);

      setAfterClearOutFit(true);
    } else if (currentOutfit[0] == '') {
      setOutfitList([]);

      setAfterClearOutFit(true);
    } else {
      setOutfitList(currentOutfit);
      setAfterClearOutFitProductPage(true);
    }

    setCategoryWiseFilters([]);
    setAppliedFilters([]);
    setApplySelectedFilters([]);
    setAfterApplyFilter([]);
    setCurrentCategory([]);
    setFinalArray([]);
    // afterClearBuilderCallAgain();
    SetIsFull(false);
    setIsOpen(false);

    window.$('.builderloading').slideUp(function() {
      window.$(this).remove();
    });
  };

  window.$('a.addoutfittocartclear').click(function() {
    ClearAllData();
  });

  const createShareableLinkUrl = (
    arrayOfItems,
    categoryWiseFilters,
    optionalListPreSets,
    categoyrListPreSets,
    currentCategory
  ) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create a new AbortController for this request
    const controller = new AbortController();
    const signal = controller.signal;
    abortControllerRef.current = controller;

    let processedFilters;
    let processedData;

    // console.log(arrayOfItems,'arrayOfItems first')
    arrayOfItems.forEach((elst, index) => {
      delete elst.gmsProductId;
      delete elst.hasImage;
      delete elst.imageUrl;
      delete elst.options;
      delete elst.parentProductId;
      delete elst.parent_product_id;
      delete elst.productDescription;
      delete elst.productHandle;
      delete elst.resultType;
      delete elst.score;
      delete elst.title;
      delete elst.url_product;
      delete elst.gmsProductId;
      // delete elst.groupset;
      delete elst.hasImage;
      delete elst.imageUrl;
      delete elst.parent_product_id;
      delete elst.resultType;
      delete elst.score;
      delete elst.abs_string;
      delete elst.astring;
    });

    categoyrListPreSets = Buffer.from(
      JSON.stringify(categoyrListPreSets)
    ).toString('base64');
    optionalListPreSets = Buffer.from(
      JSON.stringify(optionalListPreSets)
    ).toString('base64');

    if (arrayOfItems && arrayOfItems.length > 0) {
      //commenting this becaues we are not able to parse the symbol 🗲 in filters back to JSON
      // this will be uncommented once we find out the parsing solution for this
      processedData = Buffer.from(JSON.stringify(arrayOfItems)).toString(
        'base64'
      );
    } else {
      processedData = 'nodata';
    }
    if (categoryWiseFilters && categoryWiseFilters.length > 0) {
      // processedFilters = JSON.stringify(categoryWiseFilters);
      // processedFilters = encodeURI(JSON.stringify(categoryWiseFilters));
      // processedFilters = Buffer.from(JSON.stringify(processedFilters)).toString(
      //   'base64'
      // );
    }
    let urlmainNew = window.location.href;
    let urlmainNewFirst = urlmainNew.split('#')[0];
    let p1, p2, p3, p4;
    if (processedData != undefined) {
      p1 = `&selectedData=${processedData}`;
    } else {
      p1 = `&selectedData=${processedData}`;
    }

    if (processedFilters != undefined) {
      p2 = `&selectedFilters=${processedFilters}`;
    } else {
      p2 = ``;
    }

    if (processedData != undefined) {
      p3 = `&catone=${categoyrListPreSets}`;
      p4 = `&cattwo=${optionalListPreSets}`;
    }

    let currenCatShare = Buffer.from(
      JSON.stringify(currentCategory ? currentCategory : 'full')
    ).toString('base64');

    const shareableLink =
      urlmainNewFirst +
      `#smartBuilder&blank=true` +
      p1 +
      `` +
      p2 +
      `` +
      `&currentcat=${currenCatShare}`;
    const productUrl = () => `{
    "url": "${shareableLink}",
    "domain": "tiny.one",
    "alias": "",
    "tags": ""
  }`;
    const GRAPHQL_URL = () => {
      return {
        method: 'POST',
        headers: {
          accept: 'application/json',
          // 'Authorization': 'Bearer https',
          'Content-Type': 'application/json',
        },
        body: productUrl(),
        signal,
      };
    };

    if (window.location.host == 'localhost:3000') {
      // navigator.clipboard.writeText(shareableLink);

      setTimeout(function() {
        setTimeout(() => {
          // navigator.clipboard.writeText(copyText);
          setInputData(shareableLink);
          // alert('Copied the text: ' );
          setshareButtonTitle('Link Copied!');
        }, 3000);
        setTimeout(() => {
          setshareButtonTitle('Share Outfit');
        }, 9000);
      }, 2000);
    } else {
      const tinyUrl = fetch(
        // old Token : j0krdZOsoGKoY2gev38VdsniCtHRkXI06kHddzhQSmJy54T8uq7oc3auQPFB
        'https://api.tinyurl.com/create?api_token=j0krdZOsoGKoY2gev38VdsniCtHRkXI06kHddzhQSmJy54T8uq7oc3auQPFB',
        // New Token : mwpXriMGudDowi1RRFv9HMPcZjDZJ1uJSKlZob1wGbRyi5iKZxFCHMXqaQzg
        // 'https://api.tinyurl.com/create?api_token=mwpXriMGudDowi1RRFv9HMPcZjDZJ1uJSKlZob1wGbRyi5iKZxFCHMXqaQzg',
        GRAPHQL_URL()
      )
        .then(res => res.json())
        .then(function(result) {
          return result.data.tiny_url;
        })
        .catch(function(error) {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted');
          } else {
            console.error('Fetch error:', error);
          }
        });
      tinyUrl.then(function(result) {
        if (result != undefined) {
          setInputData(result);
          // setTimeout(function() {
          //   // navigator.clipboard.writeText(result);
          //   setTimeout(() => {
          //     // navigator.clipboard.writeText(copyText);
          //     if (!stopRunShareFun) {
          //       setshareButtonTitle('Link Copied!');
          //     }
          //   }, 3000);
          //   setTimeout(() => {
          //     setshareButtonTitle('Share Outfit');
          //   }, 9000);
          // }, 2000);
        }
      });
    }
  };

  return (
    <>
      <div className="outfit-mobile" id="outfit-mobile" {...handlersUp}>
        <div className="outfit-uparrow">
          <a className="swipup">
            <i className="arrow up"></i>
            {mobileButtonText ? mobileButtonText : 'View Outfit'}
          </a>
        </div>
        <div className="outfit-m-left">
          <h5 className="outfit-m-left-title">
            {' '}
            {outfitHeading ? outfitHeading : 'Your Outfit'}
            <span>
              {outfitList.length}{' '}
              {outfitList.length === 1 ? ' Product' : ' Products'}
            </span>
          </h5>
        </div>
        <div className="outfit-m-right">
          <h5 className="outfit-m-right-total">
            {' '}
            Subtotal:
            <span>
              <FormattedNumber
                value={getTotal()}
                style="currency"
                currency="USD"
                minimumFractionDigits={2}
                maximumFractionDigits={2}
              />
              {defaultCurrencySub ? ` ` + defaultCurrencySub : ''}
            </span>
          </h5>
        </div>
      </div>
      <div className="outfit-result" id="desktop-outfit">
        <div className="outfit-header" {...handlersDown}>
          <h5>{outfitHeading ? outfitHeading : 'Your Outfit'}</h5>
          <span className="close-outfit">
            Close<i className="arrow down"></i>
          </span>
        </div>
        <div className="outfit-products">{productList}</div>
        <div className="outfit-footer">
          <div>
            <h3 className="dc-sidebar--subtotal">
              Subtotal:
              <span>
                <FormattedNumber
                  value={getTotal()}
                  style="currency"
                  currency="USD"
                  minimumFractionDigits={2}
                  maximumFractionDigits={2}
                />
                {defaultCurrencySub ? ` ` + defaultCurrencySub : ''}
              </span>
            </h3>
          </div>
          <div>
            {outfitbuttonshow ? (
              <a
                id="addoutfittocart"
                style={{ width: '100%', backgroundColor: '#009FE7' }}
                data-userid={userId}
                className="dc-outfit-button"
                productsadded={variantsAdded.length === 0 ? ' ' : variantsAdded}
                reelid={ReelId}
                recommendationSource={'SmartBuilder'}
                modelVersion={'V2'}
                modelShortName={configData.input.builder_short_name}
                modelID={configData.input.builder_uid}
                additionaloptions={
                  optionsDetails.details !== undefined
                    ? JSON.stringify(optionsDetails.details)
                    : ' '
                }
                basefinalproductid={baseItemProductSku}
                onClick={() => {
                  if (outfitList.length !== 0) {
                    window
                      .$('body')
                      .append(
                        "<div class='builderloading' style='display:none;'><h4>Stand by while we get your gear together.</h4><img src='https://cdn.shopify.com/s/files/1/0336/0607/4500/files/loading.gif?v=1633341854'></div>"
                      );
                    setTimeout(function() {
                      window.$('.builderloading').fadeIn();
                    }, 20);
                    setTimeout(function() {
                      // ClearAllData();
                    }, 2000);
                  }

                  afterClearBuilderCallAgain();
                }}
              >
                {buttonText}
              </a>
            ) : null}

            {outfitbuttonshow ? null : (
              <a
                style={{ width: '100%', backgroundColor: '#009FE7' }}
                className="dc-outfit-button optionaddedbutton"
                onClick={() => {
                  if (outfitList.length !== 0) {
                    if (OpenPopReels == true) {
                      setShowOptions(true);
                      setOutfitbuttonshow(true);
                    }
                  }
                }}
              >
                {buttonText}
              </a>
            )}
            {inputData ? <CopyBoard inputData={inputData} /> : ' '}

            {checkprefiltered ? (
              <a
                className={
                  inputData ? 'dc-share-button displaynone' : 'dc-share-button'
                }
                onClick={() => {
                  createShareableLinkUrl(
                    outfitList,
                    categoryWiseFilters,
                    optionalListPreSets,
                    categoyrListPreSets,
                    currentCategory
                  );

                  setStopRunShareFun(false);
                  setshareButtonTitle('Processing');
                }}
              >
                {shareButtonTitle}
              </a>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>

      <a
        id="addoutfittocartclear"
        className="addoutfittocartclear"
        onClick={() => {
          ClearAllData();
        }}
      ></a>
    </>
  );
};

export default OutFitComponent;
